import { AnimatedContentLoader } from '@root/components'
import AccountingRuleFormModal from '@pages/SettingsPage/sections/AutomationSettings/AccountingRule/Form/AccountingRuleFormModal'
import { useInfiniteAccountingRules } from '@root/query/hooks'
import styled from 'styled-components'
import { collectFromPages } from '@root/query'
import AccountingRulesList from '@pages/SettingsPage/sections/AutomationSettings/AccountingRule/AccountingRulesList'
import AccountingRuleDeleteModal from '@pages/SettingsPage/sections/AutomationSettings/AccountingRule/AccountingRuleDeleteModal'
import AccountingRulesLander from '@pages/SettingsPage/sections/AutomationSettings/AccountingRule/AccountingRulesLander'
import { useOpenAccountingRuleFromQuery } from '@pages/SettingsPage/sections/AutomationSettings/AccountingRule/useOpenAccountingRuleFromQuery'

interface Props {
  createRequest: number
}

export const AccountingRulesTab: React.FC<Props> = ({ createRequest }) => {
  const {
    isFormOpen,
    formRule,
    deleteRule,
    isDeleteFormOpen,
    onEditRule,
    onDeleteRule,
    onFormClose,
    onCreateRule
  } = useOpenAccountingRuleFromQuery(createRequest)

  const { data, isLoading, hasNextPage, fetchNextPage } = useInfiniteAccountingRules()

  const accountingRules = collectFromPages(data)

  return (
    <PageContent>
      <AnimatedContentLoader isLoading={isLoading}>
        {accountingRules.length === 0 ? (
          <EmptyCard>
            <AccountingRulesLander onCreateRule={onCreateRule} />
          </EmptyCard>
        ) : (
          <RulesSection>
            <RulesWrapper>
              <AccountingRulesList
                grow
                accountingRules={accountingRules}
                onScrollBottom={() => {
                  if (hasNextPage) {
                    fetchNextPage()
                  }
                }}
                onEditRule={onEditRule}
                onDeleteRule={onDeleteRule}
              />
            </RulesWrapper>
          </RulesSection>
        )}
      </AnimatedContentLoader>

      <AccountingRuleFormModal isVisible={isFormOpen} rule={formRule} handleOnClose={onFormClose} />

      <AccountingRuleDeleteModal
        rule={deleteRule}
        isVisible={isDeleteFormOpen}
        handleOnClose={onFormClose}
      />
    </PageContent>
  )
}

const PageContent = styled.div`
  display: flex;
  flex-direction: column;
`

const EmptyCard = styled.div`
  width: 100%;
  max-width: 960px;
  background: ${({ theme }) => theme.colors.neutralWhite};
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  overflow: hidden;
`

const RulesSection = styled.div`
  width: 100%;
  max-width: 960px;
`

const RulesWrapper = styled.div`
  overflow: hidden;
  background: ${({ theme }) => theme.colors.neutralWhite};
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
`
